export const m = {
  append: 'append',
  delete: 'delete',
  batchDelete: 'batch delete',
  editor: 'editor',
  query:'query',
  cancel:'cancel',
  confirmAppend:'confirmAppend',
  confirmEditor:'confirmEditor',
}



// WEBPACK FOOTER //
// ./src/assets/en.js